// extracted by mini-css-extract-plugin
module.exports = {"nearbyCams":"NearbySpots_nearbyCams__7gyb7","headerContainer":"NearbySpots_headerContainer__gS4Hs"};